import { ComponentType } from 'preact'
import { YogaWidgetBase, InitData } from '../../core'
import { KlinikScheduleWidget } from './KlinikScheduleWidget'

/**
 * <holdstyring-klinik-schedule> Web Component
 *
 * The clinic house's combined "first available" treatment times across its
 * member clinics, for embedding on the house's own external website. Requires
 * an api-key belonging to the GROUP OWNER tenant — other keys get a 404 from
 * the API and the widget shows its error state.
 *
 * Clicking a time opens the member clinic's own booking page in a new tab.
 * Leaving the site is deliberate: booking and payment must happen in the
 * clinic's own flow under the clinic's own CVR.
 *
 * Attributes:
 *   api-key: Required. The group owner's Holdstyring API key.
 *   tenant-slug / base-url: Required on external sites (see HoldstyringWidgetBase).
 *   title="Ledige tider": Optional heading shown above the widget (default: none).
 *   theme-*: Optional. See HoldstyringWidgetBase.observedAttributes.
 *
 * Example:
 *   <holdstyring-klinik-schedule api-key="wk_live_xxx" tenant-slug="huset"></holdstyring-klinik-schedule>
 */
class HoldstyringKlinikScheduleElement extends YogaWidgetBase {
  protected getComponent(): ComponentType<{ initData: InitData }> {
    return KlinikScheduleWidget
  }

  protected getWidgetProps() {
    return {
      title: this.getAttribute('title') || null,
    }
  }
}

if (!customElements.get('holdstyring-klinik-schedule')) {
  customElements.define('holdstyring-klinik-schedule', HoldstyringKlinikScheduleElement)
}

export { HoldstyringKlinikScheduleElement }
